/**
 * How one person relates to a patient — a guarantor's relationship, an insurance subscriber's, an
 * emergency contact's. primary owns this vocabulary.
 */
export var Relationship;
(function (Relationship) {
    Relationship["AdoptedChild"] = "ADOPTED_CHILD";
    Relationship["Aunt"] = "AUNT";
    Relationship["AuntUncle"] = "AUNT_UNCLE";
    Relationship["Brother"] = "BROTHER";
    Relationship["CadaverDonor"] = "CADAVER_DONOR";
    Relationship["Child"] = "CHILD";
    Relationship["ChildInLaw"] = "CHILD_IN_LAW";
    Relationship["ChildNoFinancial"] = "CHILD_NO_FINANCIAL";
    Relationship["CollateralDependent"] = "COLLATERAL_DEPENDENT";
    Relationship["CourtAppointedGuardian"] = "COURT_APPOINTED_GUARDIAN";
    Relationship["Cousin"] = "COUSIN";
    Relationship["Daughter"] = "DAUGHTER";
    Relationship["DepChild"] = "DEP_CHILD";
    Relationship["DependentOfMinorDependent"] = "DEPENDENT_OF_MINOR_DEPENDENT";
    Relationship["DomesticPartnership"] = "DOMESTIC_PARTNERSHIP";
    Relationship["Donor"] = "DONOR";
    Relationship["EmancipatedMinor"] = "EMANCIPATED_MINOR";
    Relationship["Employee"] = "EMPLOYEE";
    Relationship["Employer"] = "EMPLOYER";
    Relationship["ExSpouse"] = "EX_SPOUSE";
    Relationship["Father"] = "FATHER";
    Relationship["FatherInLaw"] = "FATHER_IN_LAW";
    Relationship["FosterChild"] = "FOSTER_CHILD";
    Relationship["FosterParent"] = "FOSTER_PARENT";
    Relationship["Friend"] = "FRIEND";
    Relationship["Grandchild"] = "GRANDCHILD";
    Relationship["Granddaughter"] = "GRANDDAUGHTER";
    Relationship["Grandfather"] = "GRANDFATHER";
    Relationship["Grandmother"] = "GRANDMOTHER";
    Relationship["Grandparent"] = "GRANDPARENT";
    Relationship["Grandson"] = "GRANDSON";
    Relationship["GreatGrandfather"] = "GREAT_GRANDFATHER";
    Relationship["GreatGrandmother"] = "GREAT_GRANDMOTHER";
    Relationship["Guardian"] = "GUARDIAN";
    Relationship["HandicappedDependent"] = "HANDICAPPED_DEPENDENT";
    Relationship["Husband"] = "HUSBAND";
    Relationship["InjuredPlaintiff"] = "INJURED_PLAINTIFF";
    Relationship["InLaw"] = "IN_LAW";
    Relationship["Legal"] = "LEGAL_GUARDIAN";
    Relationship["LifePartner"] = "LIFE_PARTNER";
    Relationship["Mother"] = "MOTHER";
    Relationship["MotherInLaw"] = "MOTHER_IN_LAW";
    Relationship["Neighbor"] = "NEIGHBOR";
    Relationship["NieceNephew"] = "NIECE_NEPHEW";
    Relationship["OrganDonor"] = "ORGAN_DONOR";
    Relationship["Other"] = "OTHER";
    Relationship["OtherAdult"] = "OTHER_ADULT";
    Relationship["OverageDependent"] = "OVERAGE_DEPENDENT";
    Relationship["Parent"] = "PARENT";
    Relationship["ParentInLaw"] = "PARENT_IN_LAW";
    Relationship["Recipient"] = "RECIPIENT";
    Relationship["Relative"] = "RELATIVE";
    Relationship["Roommate"] = "ROOMMATE";
    Relationship["Self"] = "SELF";
    Relationship["Sibling"] = "SIBLING";
    Relationship["SiblingInLaw"] = "SIBLING_IN_LAW";
    Relationship["SignificantOther"] = "SIGNIFICANT_OTHER";
    Relationship["Sister"] = "SISTER";
    Relationship["Son"] = "SON";
    Relationship["Sponsor"] = "SPONSOR";
    Relationship["SponsoredDependent"] = "SPONSORED_DEPENDENT";
    Relationship["Spouse"] = "SPOUSE";
    Relationship["Stepchild"] = "STEPCHILD";
    Relationship["Stepparent"] = "STEPPARENT";
    Relationship["Stepfather"] = "STEPFATHER";
    Relationship["Stepmother"] = "STEPMOTHER";
    Relationship["Student"] = "STUDENT";
    Relationship["Uncle"] = "UNCLE";
    Relationship["Unknown"] = "UNKNOWN";
    Relationship["Unverified"] = "UNVERIFIED_PROXY";
    Relationship["Ward"] = "WARD";
    Relationship["Wife"] = "WIFE";
})(Relationship || (Relationship = {}));
//# sourceMappingURL=relationship.js.map